export const COMPLETED_REQUEST_SESSION_STORAGE_KEY = '_nightWatchCompletedRequests';
export const REQUEST_SESSION_STORAGE_KEY = '_nightWatchRequests';
export const MAX_LOCAL_STORAGE_VALUES = 50;
